// @ts-nocheck
import { populate } from 'populate';
import type { Container, NineSlicePlane, AnimatedSprite } from 'pixi.js';

const raw = {
  width: 664,
  height: 667,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: null,
      stateByName: {}
    },
    {
      id: '68c6042a-f1fd-44c9-99e3-300ae6b18ec3',
      type: 'NineSlicePlane',
      runtimeType: null,
      name: 'glow',
      className: '',
      x: -99,
      y: -80,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 200,
      height: 172,
      leftWidth: 0,
      topHeight: 85,
      rightWidth: 0,
      bottomHeight: 85,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tile_glow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '11354d92-72bf-4bec-8604-9d8abfeaf973',
      type: 'NineSlicePlane',
      runtimeType: null,
      name: 'piece_d2_2',
      className: '',
      x: -51,
      y: 21,
      scale: {
        x: -1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 19,
      height: 30,
      leftWidth: 0,
      topHeight: 2,
      rightWidth: 0,
      bottomHeight: 28,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diagonal_Tape_Piece_2',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'c0932394-e37f-4b71-a107-c04fac6f1791',
      type: 'Sprite',
      runtimeType: 'AnimatedSprite',
      name: 'piece_d2_1',
      className: '',
      x: 82,
      y: -122,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diagonal_Tape_Piece_1',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'c1a5cd10-4b0b-4d8b-ba01-2d1627b7786b',
      type: 'NineSlicePlane',
      runtimeType: null,
      name: 'piece_d1_2',
      className: '',
      x: 52,
      y: 18,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 19,
      height: 30,
      leftWidth: 0,
      topHeight: 2,
      rightWidth: 0,
      bottomHeight: 28,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diagonal_Tape_Piece_2',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'ece20964-f8cc-4ea7-bf7d-f6af3701b10e',
      type: 'Sprite',
      runtimeType: 'AnimatedSprite',
      name: 'piece_d1_1',
      className: '',
      x: -81,
      y: -124,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diagonal_Tape_Piece_1',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '05b29f82-7e10-4b7f-82c8-bcf42c2c439c',
      type: 'NineSlicePlane',
      runtimeType: null,
      name: 'piece_v_2',
      className: '',
      x: -16,
      y: 60,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 28,
      height: 12,
      leftWidth: 0,
      topHeight: 3,
      rightWidth: 0,
      bottomHeight: 8,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Vertical_Tape_Piece_2',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '3a56c550-8b36-4058-9745-614062b9b23e',
      type: 'Sprite',
      runtimeType: 'AnimatedSprite',
      name: 'piece_v_1',
      className: '',
      x: -83,
      y: -137,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Vertical_Tape_Piece_1',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    }
  ],
  version: '1.0.0',
  stateNames: [],
  animations: []
} as const;

export class TapeBlockerLayout {
  static raw = raw;
  root: Container;
  glow: NineSlicePlane;
  piece_d2_2: NineSlicePlane;
  piece_d2_1: AnimatedSprite;
  piece_d1_2: NineSlicePlane;
  piece_d1_1: AnimatedSprite;
  piece_v_2: NineSlicePlane;
  piece_v_1: AnimatedSprite;

  mInternalTypes: {
    Raw: typeof raw;
    StateName: never;
    ModelByName: {
      root: typeof raw['list'][0];
      glow: typeof raw['list'][1];
      piece_d2_2: typeof raw['list'][2];
      piece_d2_1: typeof raw['list'][3];
      piece_d1_2: typeof raw['list'][4];
      piece_d1_1: typeof raw['list'][5];
      piece_v_2: typeof raw['list'][6];
      piece_v_1: typeof raw['list'][7];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
